/**
 * Enterprise-Embed (siehe Dashboard → Widget einbinden):
 * `<script async src="…/widchat.js" id="…"></script>` — One-Liner.
 *
 * `id` = workspace_embed_keys.public_key (öffentlich; neu typisch 12 Hex-Zeichen). Pro Widget ein oder mehrere Keys.
 */
export const WIDCHAT_EMBED_SCRIPT_FILENAME = "widchat.js" as const;

/** HTML-Attribut am Loader-Script, Wert = Embed-Public-Key. */
export const WIDCHAT_EMBED_LOADER_ATTR = "id" as const;

/**
 * Erlaubt: 8–64 Hex-Zeichen (DB-Defaults sind 12 oder 32 Hex).
 *
 * **Wichtig:** Server-seitig genutzt, um SQL-Wildcards in `ILIKE`-/`LIKE`-Lookups
 * (`%`, `_`) und unbekannte Sonderzeichen frühzeitig zu verwerfen, statt sich auf
 * Postgres-Pattern-Matching zu verlassen.
 */
export const WIDCHAT_EMBED_PUBLIC_KEY_REGEX = /^[a-f0-9]{8,64}$/i;

export function isValidWidchatEmbedPublicKey(value: unknown): value is string {
  return typeof value === "string" && WIDCHAT_EMBED_PUBLIC_KEY_REGEX.test(value);
}
